<script setup lang="ts"></script>

<template>
  <div class="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">
    <div v-for="index in 6" :key="index" class="">
      <UiSkeletonDescriptionItems :lines-count="1" />
      <UiSkeletonImage />
    </div>
  </div>
</template>
